import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'app/store';
import { type BSNState, type BSNActionTypes } from 'app/store/types';

const initialState: BSNState = {};

const jobNamesReducer = (state = initialState, action: BSNActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { bsn },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(bsn && { byId: bsn }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'bsn',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	jobNamesReducer,
);

// Selectors
export const getBSNById = ({ app: { selectedLicenseGroupId }, bsn }: RootState) => bsn[selectedLicenseGroupId].byId;

export const getBSN = createSelector([getBSNById], (BSNById) => Object.values(BSNById));
